<div>
  <ngx-skeleton-loader [theme]="{height: '3.5rem', width:'100%', 'margin-bottom': '0.3%' }" appearance="line"></ngx-skeleton-loader>
</div>
<div>
  @for (row of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track row) {
    <div>
      <ngx-skeleton-loader [theme]="{height: '2.75rem', width: '15%', 'margin-right': '0.5%', 'margin-bottom': '0.3%' }" appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '2.75rem', width: '30%', 'margin-right': '0.5%', 'margin-bottom': '0.3%' }" appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '2.75rem', width: '20%', 'margin-right': '0.5%', 'margin-bottom': '0.3%' }" appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '2.75rem', width: '20%', 'margin-right': '0.5%', 'margin-bottom': '0.3%' }" appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '2.75rem', width: '13%', 'margin-bottom': '0.3%' }" appearance="line"></ngx-skeleton-loader>
    </div>
  }
</div>
<div class="paginator">
  <ngx-skeleton-loader [theme]="{ height: '2.5rem', width: '40%', 'margin-bottom': '0.3%' }" appearance="line"></ngx-skeleton-loader>
</div>
